import * as stylex from "@stylexjs/stylex";
import { layoutAreas } from "../../materials/consts.stylex";
export function Header({ children }) {
    return <div className="xki0xp4 x78zum5 x1qughib">{children}</div>;
}
